import React, { FC } from 'react';
import { useDispatch } from 'react-redux';

import Btn from '../../../modules/btn';
import { IntroHintsType } from '../../../services/api/dto/Accounts';
import { setHintInfo } from '../../../store/actions/auth';

import { HINT_INFO } from './mock';

import './index.scss';

interface IHintContainerProps {
  hint: IntroHintsType;
}

const HintContainer: FC<IHintContainerProps> = ({ hint }) => {
  const dispatch = useDispatch();

  const { title, description } = HINT_INFO[hint];

  return (
    <div className="hint-container">
      <svg width="92" height="80" viewBox="0 0 92 80" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.62791 0H83.9356C88.1503 0 91.5671 3.41682 91.5671 7.63148V57.2486C91.5671
        61.4633 88.1503 64.8801 83.9356 64.8801H76.3005V80L61.1807 64.8801H7.62791C3.41682
        64.8801 0 61.4633 0 57.2486V7.63148C0 3.41682 3.41324 0 7.62791 0ZM83.9356 61.0626C86.0358
        61.0626 87.7495 59.3524 87.7495 57.2486V7.63148C87.7495 5.52773 86.0393 3.81753 83.9356
        3.81753H7.62791C5.52773 3.81753 3.81395 5.52773 3.81395 7.63148V57.2486C3.81395 59.3524
        5.52415 61.0626 7.62791 61.0626H62.7621L72.4866 70.7871V61.0626H83.9356ZM41.9674 32.4508C41.9674
        30.347 43.674 28.6368 45.7813 28.6368C47.8887 28.6368 49.5953 30.347 49.5953 32.4508C49.5953
        34.5581 47.8887 36.2648 45.7813 36.2648C43.674 36.2648 41.9674 34.5546 41.9674 32.4508ZM61.0409
        28.6368C58.9335 28.6368 57.2269 30.347 57.2269 32.4508C57.2269 34.5546 58.9335 36.2648 61.0409
        36.2648C63.1482 36.2648 64.8548 34.5581 64.8548 32.4508C64.8548 30.347 63.1482 28.6368 61.0409
        28.6368ZM27.0656 32.4508C27.0656 30.347 28.7722 28.6368 30.8796 28.6368C32.9869 28.6368 34.6935
        30.347 34.6935 32.4508C34.6935 34.5581 32.9869 36.2648 30.8796 36.2648C28.7722 36.2648 27.0656 34.5546 27.0656 32.4508Z"
          fill="#4EBD25"
        />
      </svg>
      <h2>{title}</h2>
      <p>{description}</p>
      <Btn
        onClick={() => dispatch(setHintInfo({ type: 'INTRO', hint }))}
        text="Понятно"
        buttonType="text"
      />
    </div>
  );
};

export default HintContainer;
